"use client";

import { SelectedFilterCount } from "@/components/common/selected-filter-count";
import { businessFiltersAtom } from "@/app/(saas)/(app)/businesses/_components/filters/state";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useAtom } from "jotai";
import {
  PriceChangeFilter,
  getPriceChangeFilterCount,
} from "@/app/(saas)/(app)/businesses/_components/filters/price-change-filter";

export function PriceChangeFilterPopover() {
  const [filters, setFilters] = useAtom(businessFiltersAtom);
  const activeCount = getPriceChangeFilterCount(filters);

  function clearAll() {
    setFilters((prev) => ({
      ...prev,
      priceDirection: null,
      priceChangedWithinDays: null,
      minPriceChangePercent: null,
    }));
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="min-w-0 h-full justify-between">
          <div className="flex items-center gap-2 min-w-0">
            {activeCount > 0 && <SelectedFilterCount count={activeCount} />}
            <span className="overflow-hidden text-ellipsis">Price Changes</span>
          </div>
          <Icon icon="ChevronDown" />
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="w-[260px] p-0">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div className="text-sm font-medium">Price Changes</div>
          {activeCount > 0 && (
            <button
              type="button"
              onClick={clearAll}
              className="text-xs text-muted-foreground transition-colors hover:text-foreground hover:underline"
            >
              Clear all
            </button>
          )}
        </div>
        <div className="p-4">
          <PriceChangeFilter showClear={false} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
